import "./SuggestionCard.css";
import { FaArrowRight, FaFootballBall, FaGlobe, FaHeart, FaUser } from "react-icons/fa";
import { useTranslation } from "react-i18next";


export default function SuggestionCard({ profile, onLike, onPass }) {

  const { t } = useTranslation();

  const ROLE_LABELS = {
    Lawyer: t("suggestionCard.lawyer"),
    Athlete: t("suggestionCard.athlete"),
    Club: t("suggestionCard.club"),
    Brand: t("suggestionCard.brand"),
    Staff: t("suggestionCard.staff"),
    Fan: t("suggestionCard.fan"),
    Media: t("suggestionCard.media")
  };

  if (!profile) {
    return (
      <div className="match-card suggestion-card-horizontal skeleton-card">
        <div className="skeleton avatar"></div>
        <div className="skeleton text"></div>
        <div className="skeleton text small"></div>
      </div>
    );
  }

  return (
    <div className="match-card suggestion-card-horizontal">

      <div className="match-header">

        {profile.avatar ? (
          <img src={profile.avatar} alt={profile.name} />
        ) : (
          <div className="avatar-placeholder">
            <FaUser />
          </div>
        )}

        <div>
          <strong>{profile.name}</strong>
          <br />

          <div className={`role-badge ${profile.role?.toLowerCase()}`}>
            {ROLE_LABELS[profile.role] || profile.role}
          </div>
        </div>

      </div>

      <div className="match-body">
        {profile.sport && <div> <FaFootballBall /> {profile.sport}</div>}
        {profile.country && <div> <FaGlobe /> {profile.country}</div>}
      </div>

      <div className="suggestion-actions">

        <button
          className="btn-pass"
          onClick={() => onPass(profile)}
        >
          <FaArrowRight /> {t("suggestionCard.pass")}
        </button>

        <button
          className="btn-like"
          onClick={() => onLike(profile)}
        >
          <FaHeart /> {t("suggestionCard.match")}
        </button>

      </div>

    </div>
  );
}